module.exports = __webpack_public_path__ + "static/img/banner_news.d727547.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banner/banner_news.png
// module id = Qz53
// module chunks = 15